import React, { useEffect, useRef, useState } from "react"
import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom"
import styled from "styled-components"
import EventsApi from "../api/EventsApi"
import SearchApi from "../api/SearchApi"
import CustomEvent from "../components/CustomEvent"
import EntityList from "../components/EntityList"
import { Flex } from "../components/Flex"
import SearchInput from "../components/SearchInput"
import { toastError } from "../toast"
import { CustomEventData, EntityItem, ModerationFlag } from "../types/entity"

const Container = styled.div`
  flex: 2;
  border-radius: 50px 0 0 50px;
  background: white;
  padding: 30px 50px;
  overflow-y: auto;
`

export default function CustomEvents() {
  const { path } = useRouteMatch()
  const history = useHistory()
  const [cursor, setCursor] = useState<string>()
  const [isLast, setIsLast] = useState<boolean>(true)
  const [items, setItems] = useState<EntityItem[]>([])
  const mounted = useRef(true)

  useEffect(() => {
    return () => {
      mounted.current = false
    }
  }, [])

  const loadElements = async () => {
    try {
      const data = await EventsApi.getCustomEvents(cursor)
      setCursor(data.next_cursor)
      setIsLast(data.is_last)
      setItems([...items, ...mapToEntityList(data.results)])
    } catch (e) {
      toastError(e)
    }
  }

  const initialLoad = async () => {
    try {
      const data = await EventsApi.getCustomEvents(cursor)
      if (mounted.current) {
        setCursor(data.next_cursor)
        setIsLast(data.is_last)
        setItems(mapToEntityList(data.results))
      }
    } catch (e) {
      toastError(e)
    }
  }

  const searchElements = async (value: string) => {
    try {
      const data = await SearchApi.searchCustomEvents(value)
      setCursor(undefined)
      setIsLast(true)
      setItems(mapToEntityList(data.data.results))
    } catch (e) {
      toastError(e)
    }
  }

  const mapToEntityList = (items: CustomEventData[]) => {
    return items.map((item) => {
      return {
        id: item.id,
        moderationFlag: ModerationFlag.OK,
        text: item.title,
      }
    })
  }

  return (
    <React.Fragment>
      <Flex direction="column">
        <SearchInput initialLoad={initialLoad} query={searchElements} />
        <EntityList
          isLast={isLast}
          loadMore={loadElements}
          items={items}
          onSelect={(item) => {
            history.push(`${path}/${item.id}`)
          }}
        />
      </Flex>
      <Container>
        <Switch>
          <Route exact path={path}>
            <h1 style={{ textAlign: "center" }}>
              Вот ю ноу эбаут роллин даун ин зе дип... Вэн ёр брейн гоуз намб ю
              кэн кол зет ментал фриз...
            </h1>
          </Route>
          <Route path={`${path}/:id`}>
            <CustomEvent />
          </Route>
        </Switch>
      </Container>
    </React.Fragment>
  )
}
